import Layout from './app/components/Layout';
import LayoutOld from './app/components/LayoutOld';
import BlogPage from './app/pages/BlogPage';
import BlogPost from './app/pages/BlogPost';
import NotFoundPage from './app/pages/404';
import { createBrowserRouter } from 'react-router-dom';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <Layout color='#0EFFD4' type='main' />,
  },
  {
    path: '/education',
    element: <Layout color='#EE6328' type='edu' />,
  },
  {
    path: '/engineering',
    element: <Layout color='#4E75FF' type='eng' />,
  },
  {
    path: '/marketers',
    element: <Layout color='#C759D9' type='mar' />,
  },
  {
    path: '/assistants',
    element: <Layout color='#FF7575' type='ass' />,
  },
  {
    path: '/nurses/hire',
    element: <Layout color='#71C348' type='nurHire' />,
  },
  {
    path: '/nurses/work',
    element: <Layout color='#71C348' type='nurWork' />,
  },
  ,
  {
    path: '/healthcare/hire',
    element: <Layout color='#71C348' type='nurHire' />,
  },
  {
    path: '/healthcare/work',
    element: <Layout color='#71C348' type='nurWork' />,
  },
  {
    path: '/nurses',
    element: <Layout color='#71C348' type='nurHire' />,
  },
  {
    path: '/sales',
    element: <Layout color='#15B0E1' type='sal' />,
  },
  {
    path: '/investors',
    element: <LayoutOld />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:id',
    element: <BlogPost />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export default routes;
